import EnvioContabilidadeIndex from "@/modules/envio-contabilidade/pages/Index";

export default [
  {
    name: "envioContabilidade",
    path: "/envio-contabilidade",
    component: EnvioContabilidadeIndex,
    meta: {
      title: "Envio automático para contabilidade",
      permission: "envio-contabilidade",
    },
  },
];
